import {useDispatch, useSelector} from "react-redux";
import {useGetUser} from "hooks";
import {ACTION_TYPE, GAME_STATE} from "utils";
import View from "./View";
import {AudioListener, Audio} from "three";
import {sendGameMessage} from "store/actions/game";
import {showPopUp} from "components/PopUp";
import {useState} from "react";
import HelperPopup from "../HelperPopup";

export default function Container() {
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);
  const {userinfo, game} = useSelector(state => state);
  const {data: user} = useGetUser(userinfo.id);
  const {gameState} = game;

  const onClickStart = () => {
    if (gameState === GAME_STATE.LOADED) {
      const listener = new AudioListener();
      const audio = new Audio(listener);
      audio.play();

      const joystick = document.querySelector("#joystick");
      const jumpButton = document.querySelector("#joystick_button_J");

      if (joystick) {
        joystick.style.visibility = "hidden";
      }

      if (jumpButton) {
        jumpButton.style.visibility = "hidden";
      }

      showPopUp(<HelperPopup />, {
        defaultPadding: false,
        transparentBackground: true,
        clearOverHidden: true,
        tutorialSetting: true,
      });

      dispatch(
        sendGameMessage({
          type: ACTION_TYPE.SEND_GAME_MESSAGE,
          message: {type: "START_GAME"},
        }),
      );
    }
  };

  const onLoadBackground = () => {
    setImageLoaded(true);
  };

  return (
    <View user={user} gameState={gameState} imageLoaded={imageLoaded} onClickStart={onClickStart} onLoadBackground={onLoadBackground} />
  );
}
